import { InjectionToken, makeEnvironmentProviders } from '@angular/core';
import { AuthConfig } from 'angular-oauth2-oidc';
import { environment } from './../environments/environment';

export const AUTH_BASE = new InjectionToken<AuthConfig>('AUTH_BASE');

export const provideAuth = () =>
  makeEnvironmentProviders([
    {
      provide: AUTH_BASE,
      useValue: environment.authConfig,
    },
  ]);
